import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { EventManager, PaginationUtil, ParseLinks, AlertService, JhiLanguageService } from 'ng-jhipster';
import {StudentService, Student} from '../../entities/student';

import { ITEMS_PER_PAGE, Principal, User, UserService, FUZZY_SEARCH_DISTANCE, CRUD_ACTIONS} from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

@Component({
    selector: 'jhi-user-mgmt',
    templateUrl: './user-management.component.html'
})
export class UserMgmtComponent implements OnInit, OnDestroy {

    currentAccount: any;
    users: any[];
    error: any;
    success: any;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    currentSearch: string;
    formattedQuery: string;
    private usersSubscription: Subscription;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private userService: UserService,
        private studentService: StudentService,
        private parseLinks: ParseLinks,
        private alertService: AlertService,
        private principal: Principal,
        private eventManager: EventManager,
        private paginationUtil: PaginationUtil,
        private paginationConfig: PaginationConfig,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
        });
        this.jhiLanguageService.setLocations(['user-management']);
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.formattedQuery = activatedRoute.snapshot.params['formattedSearch'] ? activatedRoute.snapshot.params['formattedSearch'] : '';
    }

    ngOnInit() {
        if (this.principal.hasAnyAuthoritySync(['ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' , 'ROLE_ADMIN']) === true) {
            this.principal.identity().then((account) => {
                this.currentAccount = account;
                this.loadAll();
                this.registerChangeInUsers();
            });
        }
    }

    ngOnDestroy() {
        this.routeData.unsubscribe();
        this.usersSubscription.unsubscribe();
    }

    registerChangeInUsers() {
        this.usersSubscription = this.eventManager
                                     .subscribe('userListModification',
                                     (res) => this.handleActionResult(res));
    }

    private handleActionResult(result: { action: string, content: any }) {
        let entity: any = result['content']['content'];
        let action: String = result['content']['action'];

        this.users
            .forEach((item, i) => {
                if (item.userId === entity.id || item.userLogin === entity.login) {
                    switch (action) {
                        case CRUD_ACTIONS.UPDATE:
                            // We do this mapping because the entity is a User, but the item is a Student.
                            // It is better to do this mapping to avoid getting the student linked to the user
                            entity.label = entity.firstName + ' ' + entity.lastName;
                            entity.userLogin = entity.login;
                            entity.userEmail = entity.email;
                            this.users[i] = entity;
                            break;
                        case CRUD_ACTIONS.DELETE:
                            this.users.splice(i, 1);
                            break;
                    }
                }
            });
    }

    loadAll() {
        if (this.formattedQuery) {
            this.studentService.search({
                page: this.page - 1,
                query: this.formattedQuery,
                size: this.itemsPerPage
            }).subscribe(
                (res: HttpResponse<Student[]>) => this.onSuccess(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res)
                );
            return;
        }

        this.studentService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(
            (res: HttpResponse<Student[]>) => this.onSuccess(res.body, res.headers),
            (res: HttpResponse<any>) => this.onError(res)
            );
    }

    search(query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;

        let strippedQuery: string = query.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '');
        if (strippedQuery.includes('@')) {
            // if an email is given, we search for the exact match
            // TODO improve this when an improvement in the backend is made to use
            // an analyzer or tokenizer more apropiate for emails in elasticsearch.
            this.formattedQuery = '"' + strippedQuery + '"';
        } else {
            // if a phrase is given, we search for the login, first name or lastname
            // refer to the elasticsearch query string syntax for help of exact, fuzzy and proximity matches.
            this.formattedQuery = 'userLogin:' + strippedQuery + '~' + FUZZY_SEARCH_DISTANCE;
            this.formattedQuery = this.formattedQuery +
                strippedQuery.split(/[ ]+/).reduce((acumQuery, token) => {
                    let fuzzyToken =  token !== '' ? ' OR user.firstName:' + token + '~' + FUZZY_SEARCH_DISTANCE +
                    ' OR ' + 'user.lastName:' + token + '~' + FUZZY_SEARCH_DISTANCE : '';
                    return acumQuery + ' ' + fuzzyToken;
            }, '');
        }
        this.currentSearch = query;
        this.router.navigate(['/user-management', {
            search: this.currentSearch,
            formattedSearch: this.formattedQuery,
            page: this.page
        }]);
        this.loadAll();
    }

    clear() {
        this.page = 0;
        this.currentSearch = '';
        this.formattedQuery = '' ;
        this.router.navigate(['/user-management', {
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        }]);
        this.loadAll();
    }

    trackIdentity(index, item: User) {
        return item.id;
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        return result;
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['/user-management'], {
            queryParams:
            {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    }

    private onSuccess(data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.users = data;
    }

    private onError(error) {
        this.alertService.error(error.error, error.message, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-management/user-management.component.ts